// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"controlButton___2GX1D","buttonWrap":"buttonWrap___2v4Ny","card":"card___C3erJ"};